/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1LocationCountries202,
  PostApiV1LocationCountries400,
  PostApiV1LocationCountries401,
  PostApiV1LocationCountries409,
  PostApiV1LocationCountries500,
  PostApiV1LocationCountriesMutationRequest,
  PostApiV1LocationCountriesMutationResponse,
} from "../../types/locationCountryController/PostApiV1LocationCountries.ts";
import { countryViewModelSchema } from "../countryViewModelSchema.ts";
import { createCountryRequestViewModelSchema } from "../createCountryRequestViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1LocationCountries202Schema = z.lazy(
  () => countryViewModelSchema,
) as unknown as ToZod<PostApiV1LocationCountries202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1LocationCountries400Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCountries400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1LocationCountries401Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCountries401>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1LocationCountries409Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCountries409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1LocationCountries500Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCountries500>;

export const postApiV1LocationCountriesMutationRequestSchema = z.lazy(
  () => createCountryRequestViewModelSchema,
) as unknown as ToZod<PostApiV1LocationCountriesMutationRequest>;

export const postApiV1LocationCountriesMutationResponseSchema = z.lazy(
  () => postApiV1LocationCountries202Schema,
) as unknown as ToZod<PostApiV1LocationCountriesMutationResponse>;
